const state = () => ({
    backgrounds: false,
    speedText: false,
    backgroundVideoMp4: false,
    backgroundVideoWebm: false,
    maxSymbol: false,
    freeSeconds: false,
    defaultPrice: false,
    waitingPayment: 0,
    reserveTime: 0,
    priceMusic: false,
    priceWeekend: false,
    priceHolidays: false,
    pricePrimeTime: false,
    priceSurveyGround: false,
    priceSurveyAerial: false,
    priceSurveyGroundAerial: false,
    maxBlocks: false,
    newSpeedText: false
})

const mutations = {
    setBackgrounds(state, { backgrounds }) {
        state.backgrounds = backgrounds
    },
    setSpeedText(state, { speed }) {
        state.speedText = speed
    },
    setBackgroundVideoMp4(state, { video }) {
        state.backgroundVideoMp4 = video
    },
    setBackgroundVideoWebm(state, { video }) {
        state.backgroundVideoWebm = video
    },
    setMaxSymbol(state, { symbol }) {
        state.maxSymbol = symbol
    },
    setFreeSeconds(state, { seconds }) {
        state.freeSeconds = seconds
    },
    setDefaultPrice(state, { price }) {
        state.defaultPrice = price
    },
    setPriceMusic(state, { price }) {
        state.priceMusic = price
    },
    setPriceWeekend(state, { price }) {
        state.priceWeekend = price
    },
    setPriceHolidays(state, { price }) {
        state.priceHolidays = price
    },
    setPricePrimeTime(state, { price }) {
        state.pricePrimeTime = price
    },
    setPriceSurveyGround(state, { price }) {
        state.priceSurveyGround = price
    },
    setPriceSurveyAerial(state, { price }) {
        state.priceSurveyAerial = price
    },
    setPriceSurveyGroundAerial(state, { price }) {
        state.priceSurveyGroundAerial = price
    },
    setWaitingPayment(state, { time }) {
        state.waitingPayment = time
    },
    setReserveTime(state, { time }) {
        state.reserveTime = time
    },
    setMaxBlocks(state, blocks) {
        state.maxBlocks = blocks
    },
    setNewSpeedText(state, {speed}) {
        state.newSpeedText = speed
    }
}

const actions = {
    setBackgrounds({ commit }, { backgrounds }) {
        commit('setBackgrounds', { backgrounds })
    },
    setSpeedText({ commit }, { speed }) {
        commit('setSpeedText', { speed })
    },
    setNewSpeedText({ commit }, { speed }){
        commit('setNewSpeedText', { speed })
    },
    setBackgroundVideoMp4({ commit }, { video }) {
        commit('setBackgroundVideoMp4', { video })
    },
    setBackgroundVideoWebm({ commit }, { video }) {
        commit('setBackgroundVideoWebm', { video })
    },
    setMaxSymbol({ commit }, { symbol }) {
        commit('setMaxSymbol', { symbol })
    },
    setFreeSeconds({ commit }, { seconds }) {
        commit('setFreeSeconds', { seconds })
    },
    setDefaultPrice({ commit }, { price }) {
        commit('setDefaultPrice', { price })
    },
    setPriceMusic({ commit }, { price }) {
        commit('setPriceMusic', { price })
    },
    setPriceWeekend({ commit }, { price }) {
        commit('setPriceWeekend', { price })
    },
    setPriceHolidays({ commit }, { price }) {
        commit('setPriceHolidays', { price })
    },
    setPricePrimeTime({ commit }, { price }) {
        commit('setPricePrimeTime', { price })
    },
    setPriceSurveyGround({ commit }, { price }) {
        commit('setPriceSurveyGround', { price })
    },
    setPriceSurveyAerial({ commit }, { price }) {
        commit('setPriceSurveyAerial', { price })
    },
    setPriceSurveyGroundAerial({ commit }, { price }) {
        commit('setPriceSurveyGroundAerial', { price })
    },
    setWaitingPayment({ commit }, { time }) {
        commit('setWaitingPayment', { time })
    },
    setReserveTime({ commit }, { time }) {
        commit('setReserveTime', { time })
    },
    setMaxBlocks({ commit }, blocks) {
        commit('setMaxBlocks', blocks)
    }
}


const getters = {
    backgrounds: state => state.backgrounds,
    newSpeedText: state => state.newSpeedText,
    speedText: state => state.speedText,
    backgroundVideoMp4: state => state.backgroundVideoMp4,
    backgroundVideoWebm: state => state.backgroundVideoWebm,
    maxSymbol: state => state.maxSymbol,
    freeSeconds: state => state.freeSeconds,
    waitingPayment: state => state.waitingPayment,
    reserveTime: state => state.reserveTime,
    defaultPrice: state => state.defaultPrice,
    priceMusic: state => state.priceMusic,
    priceWeekend: state => state.priceWeekend,
    priceHolidays: state => state.priceHolidays,
    pricePrimeTime: state => state.pricePrimeTime,
    priceSurveyGround: state => state.priceSurveyGround,
    priceSurveyAerial: state => state.priceSurveyAerial,
    priceSurveyGroundAerial: state => state.priceSurveyGroundAerial,
    maxBlocks: state => state.maxBlocks
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};